// extracted by mini-css-extract-plugin
export default {"container":"footer_container__IOuo5"};